import { ReduxEntity, Action } from "app/types/app-types"
import { Project } from "app/types/model-types"
import * as Sentry from '@sentry/browser';
import store from "store";

export type ProjectState = ReduxEntity<Project>

const defaultProjectState: ProjectState = {
    data: {
        id: null,
        name: null,
        contact_email: null,
        who_are_you: null,
        active_templates_count: null,
        templates_count: null,
        show_newsbox: null,
        show_first_steps: null,
        user: null,
        outputLangPrefix: null,
        shop_name: null,
        shop_id: null,
        input_format: null,
        output_format: null,
        active: null,
        deleting: null,
        e_img_url_input: null,
        e_img_url: null,
        e_alt_img_url: null,
        e_alt_img_url_input: null,
        e_first_alt_img_url: null,
        e_item_id: null,
        e_url: null,
        e_name: null,
        e_price_vat: null,
        e_ean: null,
        e_productno: null,
        enabled_at: null,
        disabled_at: null,
        input_feed: null,
        creator_id: null,
        process_apply_started_at: null,
        process_apply_finished_at: null,
        mergado_element_regex: null,
        mergado_max_payload_size: null,
        mergado_xml_equivalent: null,
        is_input_csv: 0,
        is_output_csv: 0
    },
    error: null,
    isLoaded: false,
    isLoading: false,
    updated: null,
}

export const SET_PROJECT_TO_STORE = "SET_PROJECT_TO_STORE"

export default function (state: ProjectState = defaultProjectState, action: Action<any>): ProjectState {
    switch (action.type) {
        case SET_PROJECT_TO_STORE:
            return { ...state, ...{ data: action.payload, isLoaded: true, isLoading: false, updated: new Date() } }
        default:
            return state
    }
}

export function setProjectToStore(project: Project): Action<Project> {
    if (project.user?.email) {
        Sentry.setUser({
            id: project.user.id,
            email: project.user.email,
        });

        Sentry.getCurrentScope().setTag('email', project.user.email);
    }

    return {
        type: SET_PROJECT_TO_STORE,
        payload: project
    }
}